import { Component, Input, OnInit } from '@angular/core';
import { Recommendation } from '../../interfaces';

@Component({
  selector: 'app-recommendations-list',
  styleUrls: ['./recommendations-list.component.scss'],
  templateUrl: './recommendations-list.component.html',
})
export class RecommendationsListComponent implements OnInit {
  @Input() recommendations: Recommendation[];
  @Input() topicalIngredients: Recommendation[];
  @Input() supplements: Recommendation[];

  ngOnInit() {
    if (
      this.recommendations?.length > 0 &&
      !!this.recommendations[0].sequenceNumber
    ) {
      this.recommendations
        .filter((item) => item.title && item.image)
        .sort((a, b) => a.sequenceNumber - b.sequenceNumber);
    }
  }

  propertyExists(property: string, object: Recommendation) {
    return property in object;
  }
}
